import metricEventItemView from './metricEventItemComponent.html';
import './metricEventItemComponent.css';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export function metricEventItemComponent() {
	return {
		bindings: {
			record: '<',
			showUser: '<',
		},
		controllerAs: 'vm',
		controller: metricEventItemComponentCtrl,
		template: metricEventItemView,
	};
}

export class metricEventItemComponentCtrl {
	constructor(Api) {
		'ngInject';
		// save injections but assume bindings are not yet set
		this.Api = Api;
		// initialize variables
		this.details = null;
		AssetManager.css('/assets/fonts/Linearicons/style.css');
	}

	$onInit() {
		// bindings are now set
	}

	async toggleExpand() {
		if (this.details) {
			this.details = null;
			return;
		}
		this.details = 'loading';
		this.details = await this.Api.get(`/metrics/events/${this.record.id}`);
		this.details.isLocalhost = /^192\.168\./.test(this.details.ip.address);
	}
}
